import { Vector3, BufferGeometry, LineBasicMaterial, EllipseCurve, Line } from "three";
export class Circle extends Line {
    constructor(name, color, positions = [new Vector3(0, 0, 0), new Vector3(0, 0, 1)]) {
        super(new BufferGeometry(), new LineBasicMaterial({ color: color }));
        this._curveComplexity = 50;
        this.name = name;
        this.positions = positions;
        this.interceptedByRaycaster = false;
    }
    get positions() {
        return this._positions;
    }
    set positions(values) {
        const radius = values[0].distanceTo(values[1]) / 2;
        const curve = new EllipseCurve(0, 0, radius, radius, 0, 2 * Math.PI, false, 0);
        this._positions = values;
        this.geometry.deleteAttribute("position");
        this.geometry.setFromPoints(curve.getPoints(this._curveComplexity));
        this.position.copy(values[0].clone().lerp(values[1], 0.5));
        this.geometry.computeBoundingSphere();
    }
}
//# sourceMappingURL=Circle.js.map